import React from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@rakutenfrance/mui';
const dividerStyle = {
    backgroundColor: colorPalette.gray200,
    margin: '16px 0',
};
const typoStyle = {
    color: colorPalette.gray900,
    fontSize: '14px',
    wordBreak: 'break-word',
};
export const EconomicOperatorInformation = ({ data }) => {
    return (React.createElement(Stack, null, data === null || data === void 0 ? void 0 : data.map((data, i) => {
        var _a;
        return (React.createElement(Stack, { key: data.postalCode, sx: {
                marginTop: i === 0 ? '16px' : '0',
            } },
            i !== 0 && React.createElement(Divider, { sx: dividerStyle }),
            React.createElement(Stack, { gap: 1 },
                React.createElement(Typography, { fontWeight: '600', color: colorPalette.gray900, sx: {
                        fontSize: '14px',
                    } }, (_a = data.sellerLogin) !== null && _a !== void 0 ? _a : data.sellerLogin),
                React.createElement(Stack, null,
                    React.createElement(Typography, { sx: typoStyle }, data.responsiblePerson),
                    React.createElement(Typography, { sx: typoStyle }, data.address),
                    (data === null || data === void 0 ? void 0 : data.additionalAddressDetails) && React.createElement(Typography, { sx: typoStyle }, data.additionalAddressDetails),
                    React.createElement(Typography, { sx: typoStyle },
                        data.city,
                        ", ",
                        data.postalCode,
                        ", ",
                        data.country),
                    (data === null || data === void 0 ? void 0 : data.region) && React.createElement(Typography, { sx: typoStyle }, data.region),
                    React.createElement(Typography, { sx: typoStyle }, data.phoneNumber),
                    React.createElement(Typography, { sx: typoStyle }, data.emailAddress)))));
    })));
};
